import { useQuery, UseQueryOptions } from '@lumapps/base-api/react-query';

import { getVideoThumbnail, playVideoKeys } from '../../api';

export interface UseVideoThumbnailParams {
    /** Video ID */
    videoId?: string;
    /** Retreive thumbnail from a video id or a playlist id */
    thumbnailType: 'videos' | 'playlists';
}

/**
 * Hook to fetch a video thumbnail from the API and convert it to a blob URL.
 *
 * @param params - Video thumbnail parameters
 * @param options - Additional react-query options
 * @returns Query result with the thumbnail URL
 */
export const useVideoThumbnail = (
    { videoId = '', thumbnailType }: UseVideoThumbnailParams,
    options?: UseQueryOptions,
) => {
    return useQuery({
        ...options,
        queryKey: playVideoKeys.thumbnail(thumbnailType, videoId),
        queryFn: async ({ signal }) => {
            return getVideoThumbnail(thumbnailType, videoId, signal);
        },
    });
};
